export const Spacing = {
  none: "0rem", // 0px
  "5xs": "0.125rem", // 2px
  "4xs": "0.25rem", // 4px
  "3xs": "0.4rem", // 6px
  "2xs": "0.5rem", // 8px
  xs: "0.75rem", // 12px
  sm: "1rem", // 16px
  md: "1.5rem", // 24px
  lg: "2rem", // 32px
  xl: "3rem", // 48px
  "2xl": "4rem", // 64px
  "3xl": "6rem", // 96px
  "4xl": "8rem", // 128px
  "5xl": "10rem", // 160px
  "6xl": "12rem", // 192px
  "7xl": "14rem", // 224px,
  0: "0%",
  5: "5%",
  10: "10%",
  15: "15%",
  20: "20%",
  25: "25%",
  30: "30%",
  35: "35%",
  40: "40%",
  45: "45%",
  50: "50%",
  55: "55%",
  60: "60%",
  65: "65%",
  70: "70%",
  75: "75%",
  80: "80%",
  85: "85%",
  90: "90%",
  95: "95%",
  100: "100%",
};
